import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Link } from '../../components';
import useAuthor from '../../hooks/useAuthor';

const Author = ({ components, className, name, url }) => {
  const author = useAuthor(name);

  const classes = cx(
    'author',
    {
      'u-linkDefault': url,
    },
    className
  );

  const authorContent = () => (
    <Fragment>
      {components.includes('avatar') && (
        <img src={author.frontmatter.photo} alt={author.frontmatter.title} />
      )}
      {(components.includes('name') || components.includes('position')) && (
        <div className="author-content">
          {components.includes('name') && (
            <div className="u-textMedium u-textHeading">
              {author.frontmatter.title}
            </div>
          )}
          {components.includes('position') && (
            <div className="u-textMuted u-textSmall">
              {author.frontmatter.position}
            </div>
          )}
        </div>
      )}
    </Fragment>
  );

  return url ? (
    <Link to={url} className={classes}>
      {authorContent()}
    </Link>
  ) : (
    <div className={classes}>{authorContent()}</div>
  );
};

Author.propTypes = {
  components: PropTypes.array,
  className: PropTypes.string,
  name: PropTypes.string,
  url: PropTypes.string,
};

Author.defaultProps = {
  components: ['avatar', 'name', 'position'],
};

export default Author;
